export const formInitialValues = {
  topic_ids: [],
  industry_ids: [],
  user_ids: [],
};
